import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { FunctionComponent } from 'react';
import styles from './UseCuddlesDefaultConfirmModal.module.scss';

interface UseCuddlesDefaultConfirmModalProps {
    /** True while the disable update is in flight — drives button loading state. */
    saving: boolean;
    onCancel: () => void;
    /** User confirmed they want to drop the custom sender. Caller dispatches
     *  the disable update and is responsible for dismissing the modal on
     *  success. */
    onConfirm: () => void;
}

/**
 * Confirmation overlay for the "Don't want a custom sender?" escape link.
 * Lifted out of the old FormState so any state component (Pending, Verified,
 * Failed) can show the escape link below the card and trigger this dialog
 * via a callback owned by EmailSenderComponent.
 */
const UseCuddlesDefaultConfirmModal: FunctionComponent<UseCuddlesDefaultConfirmModalProps> = ({
    saving,
    onCancel,
    onConfirm
}) => {
    return (
        <GenericModal
            className={styles.modal}
            onClose={saving ? undefined : onCancel}
            footer={
                <div className={styles.footer}>
                    <Button
                        size="large"
                        className={styles.footerButton}
                        label="Cancel"
                        variant="black"
                        onClick={onCancel}
                        disabled={saving}
                    />
                    <Button
                        size="large"
                        className={styles.footerButton}
                        label="Yes, Use Default"
                        variant="green"
                        onClick={onConfirm}
                        isLoading={saving}
                        disabled={saving}
                    />
                </div>
            }
        >
            <div className={styles.content}>
                <span className={styles.title}>Use Cuddles Default?</span>
                <p className={styles.description}>
                    Future campaigns will send from <strong>emails@cuddlesapp.com</strong> using your business name. You
                    can setup a custom sender again at any time
                </p>
            </div>
        </GenericModal>
    );
};

export default UseCuddlesDefaultConfirmModal;
